import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import ModalItem from '../Components/ModalItem';
import { FaSearch } from "react-icons/fa";
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

function Annisite() {
    
    const {user}                                                          = useSelector((state) => state.auth);
    const [showModal, setShowModal]                                       = useState(false);
    ////
    const [searchWord, setSearchWord]                                     = useState("");
    const [selectedUser, setSelectedUser]                                 = useState(null);
    const [listUsersForSelect, setListUsersForSelect]                     = useState([]);
    ///
    const [linkTo, setLinkTo]                                             = useState("");
    const [listAnnisites, setListAnnisites]                               = useState([]);

    const [page, setPage]                                                 = useState(1);
    
    const [activeTab, setActiveTab]                                       = useState("general");

    const [processing, setProcessing]                                     = useState(false);

    const [formAnnisite, setFormAnnisite] = useState({
        spouseA: "",
        spouseB: "",
        status: "Anniversary",
        featureUrl: "",
        cloudinaryId: "",
        weddingDate: "",
        weddingTime: "",
        weddingAddress: {
          address: "",
        },
        onviteDetails: {
          mainEnd: "",
          receptionDate: "",
          receptionAddress: "",
          receptionStart: "",
          receptionEnd: "",
        },
      });

      const [formMemory, setFormMemory] = useState({
        experience: "",
        eventOrder: 1,
        contactEmail: "",
        contactPhone: "",
        howsItGoing: "",
      });

    useEffect(() => {
      collectListOfAnnisites();
    },[])
    
    const collectListOfAnnisites = async () =>{
        try{  
    
          const response = await axios.get(CONSTANTS.API_URL +"annivites/list/v2/onvite/" + page);
             
              console.log(response.data);
              setListAnnisites(response.data);
        }catch(err){
          console.log(err);
        }
    }

  const handleInputChange = (event) => {
      // Call setSearchWord with the new value from the input field
      setSearchWord(event.target.value);
  };

  const handleSeachUsers = async () => {
      try{
        //processing
        if(searchWord.length > 3){
         
          const res = await axios.get(CONSTANTS.API_URL +"users/search/by-user/" + searchWord, {
            headers: {
              token : "Bearer " + user.accessToken
            }
          });

          if(res.status === 200){
            setListUsersForSelect(res.data);
          }

        }else {
          toast.warning("Search has to be three characters long, (Name or Email or phone")
        }
      }catch(err){
        console.log(err);
        toast.error("Something went wrong, please try again later.")
      }
  }

  const handleChangeAnnisite = (e) => {
      const { name, value } = e.target;

      // Handle nested fields
      if (name.startsWith("weddingAddress.")) {
        const key = name.split(".")[1];
        setFormAnnisite((prev) => ({
          ...prev,
          weddingAddress: { ...prev.weddingAddress, [key]: value },
        }));
      } else if (name.startsWith("onviteDetails.")) {
        const key = name.split(".")[1];
        setFormAnnisite((prev) => ({
          ...prev,
          onviteDetails: { ...prev.onviteDetails, [key]: value },
        }));
      } else {
        // Handle top-level fields
      setFormAnnisite((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleChangeMemory = (e) => {
    const { name, value } = e.target;
    setFormMemory((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  ///////////////////////////////
  const handleCreateMemory = async () => {
    try{
      
      if(selectedUser !== null){
        
         if(formAnnisite.spouseA.length > 0 &&
            formAnnisite.spouseB.length > 0 &&
            formAnnisite.weddingDate.length > 0 &&
            formAnnisite.weddingTime.length > 0 
         ){
            const newObject = {
              "annisite" : {
                "userId"                        : selectedUser._id,
                "userName"                      : selectedUser.name,
                "spouseA"                       :  formAnnisite.spouseA,
                "weddingVowsA"                  :  "",
                "spouseB"                       :  formAnnisite.spouseB,
                "weddingVowsB"               :  "",
                "status"                     :  formAnnisite.status,
                "contactName"                :  "",
                "contactEmail"               :  "",
                "contactPhone"               :  "",
                "weddingDate"                :  formAnnisite.weddingDate,
                "weddingTime"                :  formAnnisite.weddingTime,
                "weddingAddress.address"     :  formAnnisite.weddingAddress.address,
                "weddingAddress.lat"         :  formAnnisite.weddingAddress.lat,
                "weddingAddress.lng"         :  formAnnisite.weddingAddress.lng,
                "weddingAddress.zoom"        :  10,
                "weddingOnviteMessage"       :  "",
                "weddingAnniviteMessage"     :  "",
                "weddingOnviteCatalogue"     :  [],
                "memoryEvents"               :  [],
                "featureUrl"                       :  "",
                "cloudinaryId"                     :  "",
                "onviteDetails.mainEventTitle"     :  formAnnisite.status,
                "onviteDetails.mainEventDate"      :  formAnnisite.weddingDate,                
                "onviteDetails.mainAddress"        :  formAnnisite.weddingAddress.address,
                "onviteDetails.mainStart"          :  formAnnisite.weddingTime,
                "onviteDetails.mainEnd"            :  formAnnisite.onviteDetails.mainEnd,
                "onviteDetails.receptionDate"      :  formAnnisite.onviteDetails.receptionDate,
                "onviteDetails.receptionAddress"   :  formAnnisite.onviteDetails.receptionAddress,
                "onviteDetails.receptionStart"     :  formAnnisite.onviteDetails.receptionStart,
                "onviteDetails.receptionEnd"       :  formAnnisite.onviteDetails.receptionEnd,
                "eventMessages"                    :  [],
              },
              "memory": {
                "experience"                 : formMemory.experience,
                "eventOrder"                 : formMemory.eventOrder, 
                "contactEmail"               : formMemory.contactEmail, 
                "contactPhone"               : formMemory.contactPhone, 
                "howsItGoing"                : formMemory.howsItGoing, 
                "eventMessages"              : [], 
                "imageList"                  : [], 
              }
            }

            setProcessing(true);
            const response = await axios.post(CONSTANTS.API_URL +"annivites/create/detail/v1/anniversary/", newObject, {
                  headers: {
                    token: "Bearer " + user.accessToken
                  }
                });

                console.log(response);
                //toast.success(response.data.message);
                toast.success("Thank you for creating.")
                //setLinkTo(response.data.id);
            setProcessing(false);
         }else {
          toast.warning("Please Add Spouse names and wedding date and time.")  
         }

      }else {
        toast.warning("Please select user first.")
      }
      
    }catch(err){
      console.log(err);
      setProcessing(false);
    }
  }

  return (
    <div className="card">
      <div className="card-body">
          <h3 className="inner-part">Annisite</h3>
          <div className="content-row-intro">
            <button className="btn btn-primary" onClick={() => setShowModal(true)}>
              Create +
            </button>
          </div>
           <ModalItem 
                    show={showModal} 
                    onClose={() => setShowModal(false)} 
                    title="Create Annisite"
                  >
                    <div className="body-content-part">
                        <ul className="nav nav-pills">
                            <li className="nav-item">
                              <button
                                className={`nav-link ${activeTab === "general" ? "active" : ""}`}
                                onClick={() => setActiveTab("general")}
                              >
                                General
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className={`nav-link ${activeTab === "annisite" ? "active" : ""}`}
                                onClick={() => setActiveTab("annisite")}
                              >
                                Annisite
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className={`nav-link ${activeTab === "memory" ? "active" : ""}`}
                                onClick={() => setActiveTab("memory")}
                              >
                                Memory
                              </button>
                            </li>
                        </ul>   

                        <div className="tab-content p-3 border rounded">
                          {
                            activeTab === "general" && (
                              <div className="tab-body-ct">
                                 <div className="form-block">
                                  <div className="mt-2 flexme">
                                    <input 
                                      type="text" 
                                      className="form-control" 
                                      value={searchWord} // This makes the input a "controlled component"
                                      onChange={handleInputChange}  /><button className="btn btn-warning" onClick={handleSeachUsers}><FaSearch /></button>
                                  </div>
                                  {
                                    listUsersForSelect.length > 0 && (
                                      <div className="list-dialogue-box">
                                          <ul className="listing-items">
                                            {
                                              listUsersForSelect.map((item, index) => {
                                                return <li key={index}>
                                                          <button className="btn btn-full list-item" onClick={() => {
                                                            setSelectedUser(item);

                                                            setListUsersForSelect([]);
                                                            setSearchWord("");
                                                          }}>
                                                            <span>{item.name}</span>
                                                            <span>{item.surname}</span>
                                                            <span>{item.phone}</span>
                                                          </button>        
                                                        </li>
                                              })
                                            }
                                          </ul>

                                         
                                      </div>
                                    )
                                  }
                                </div>
                                 {
                                            selectedUser != null && (
                                              <div className="selected-user">
                                                 <button 
                                                    type="button" 
                                                    className="btn-close" 
                                                    onClick={() => setSelectedUser(null)}
                                                  ></button>
                                                  <div className="user-details">
                                                        <table className="table">
                                                          <tbody>
                                                            <tr>
                                                              <td>Name</td>
                                                              <td>:</td>
                                                              <td>{selectedUser.name}</td>
                                                            </tr>
                                                            <tr>
                                                              <td>Surname</td>
                                                              <td>:</td>
                                                              <td>{selectedUser.surname}</td>
                                                            </tr>
                                                             <tr>
                                                              <td>Email</td>
                                                              <td>:</td>
                                                              <td>{selectedUser.email}</td>
                                                            </tr>
                                                             <tr>
                                                              <td>Phone</td>
                                                              <td>:</td>
                                                              <td>{selectedUser.phone}</td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                          
                                                  </div>
                                              </div>
                                            )
                                          }
                              </div>
                            )
                          }  
                          {
                            activeTab === "annisite" && (
                              <div className="tab-body-ct">
                                <div className="row form-block">
                                  <div className="col-md-6 ">
                                  
                                      <div className="mb-3">
                                        <label className="form-label">Spouse A</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="spouseA"
                                          value={formAnnisite.spouseA}
                                          onChange={handleChangeAnnisite}
                                          required
                                        />
                                      </div>
                                  </div>
                                  <div className="col-md-6 ">
                                     <div className="mb-3">
                                        <label className="form-label">Spouse B</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="spouseB"
                                          value={formAnnisite.spouseB}
                                          onChange={handleChangeAnnisite}
                                          required
                                        />
                                      </div>
                                  </div>
                                  <div className="col-md-6 ">
                                    <div className="mb-3">
                                      <label className="form-label">Status</label>
                                      <select
                                        className="form-select"
                                        name="status"
                                        value={formAnnisite.status}
                                        onChange={handleChangeAnnisite}
                                      >
                                        <option value="Anniversary">Anniversary</option>
                                        <option value="Wedding">Wedding</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-6 ">
                                    <div className="mb-3">
                                      <label className="form-label">Wedding Date</label>
                                      <input
                                        type="date"
                                        className="form-control"
                                        name="weddingDate"
                                        value={formAnnisite.weddingDate}
                                        onChange={handleChangeAnnisite}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6 ">
                                    <div className="mb-3">
                                        <label className="form-label">Wedding Time</label>
                                        <input
                                          type="time"
                                          className="form-control"
                                          name="weddingTime"
                                          value={formAnnisite.weddingTime}
                                          onChange={handleChangeAnnisite}
                                        />
                                      </div>
                                  </div>
                                  
                                  <div className="col-md-6 mb-3">
                                      <label className="form-label">Wedding End</label>
                                      <input
                                        type="time"
                                        className="form-control"
                                        name="onviteDetails.mainEnd"
                                        value={formAnnisite.onviteDetails.mainEnd}
                                        onChange={handleChangeAnnisite}
                                      />
                                  </div>
                                  <div className="col-md-12 ">
                                          <div className="mb-3">
                                            <label className="form-label">Wedding Address</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              name="weddingAddress.address"
                                              placeholder="Address"
                                              value={formAnnisite.weddingAddress.address}
                                              onChange={handleChangeAnnisite}
                                            />
                                          </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="mb-3">
                                        <label className="form-label">Reception Date</label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          name="onviteDetails.receptionDate"
                                          value={formAnnisite.onviteDetails.receptionDate}
                                          onChange={handleChangeAnnisite}
                                        />
                                      </div>
                                  </div>
                                  <div className="col-md-6">
                                      <div className="mb-3">
                                        <label className="form-label">Reception Address</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="onviteDetails.receptionAddress"
                                          value={formAnnisite.onviteDetails.receptionAddress}
                                          onChange={handleChangeAnnisite}
                                        />
                                      </div>
                                    </div>
                                     <div className="col-md-6 mb-3">
                                      <label className="form-label">Reception Start</label>
                                      <input
                                        type="time"
                                        className="form-control"
                                        name="onviteDetails.receptionStart"
                                        value={formAnnisite.onviteDetails.receptionStart}
                                        onChange={handleChangeAnnisite}
                                      />
                                    </div>

                                  <div className="col-md-6 mb-3">
                                      <label className="form-label">Reception End</label>
                                      <input
                                        type="time"
                                        className="form-control"
                                        name="onviteDetails.receptionEnd"
                                        value={formAnnisite.onviteDetails.receptionEnd}
                                        onChange={handleChangeAnnisite}
                                      />
                                    </div>
                                  
                                  

                                
                                </div>
                              </div>
                            )
                          }  
                          {
                            activeTab === "memory" && (
                              <div className="tab-body-ct">
                                <div className="row form-block">
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                          <label className="form-label">Experience</label>
                                          <textarea
                                            className="form-control"
                                            name="experience"
                                            rows="3"
                                            value={formMemory.experience}
                                            onChange={handleChangeMemory}
                                            placeholder="Describe your experience..."
                                            required
                                          />
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                      <label className="form-label">Contact Email</label>
                                          <input
                                            type="email"
                                            className="form-control"
                                            name="contactEmail"
                                            value={formMemory.contactEmail}
                                            onChange={handleChangeMemory}
                                            placeholder="example@email.com"
                                          />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                      <label className="form-label">Contact Phone</label>
                                        <input
                                          type="tel"
                                          className="form-control"
                                          name="contactPhone"
                                          value={formMemory.contactPhone}
                                          onChange={handleChangeMemory}
                                          placeholder="+27 00 000 0000"
                                        />
                                    </div>
                                    <div className="col-md-12">
                                       <div className="mb-3">
                                          <label className="form-label">How's It Going?</label>
                                          <textarea
                                            rows="3"
                                            className="form-control"
                                            name="howsItGoing"
                                            value={formMemory.howsItGoing}
                                            onChange={handleChangeMemory}
                                            placeholder="e.g. Feeling great!"
                                          ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <button className="btn btn-primary" onClick={handleCreateMemory} disabled={processing}>
                                    {processing ? "processing..." : "Create"}
                                </button>
                              </div>
                            )
                          }  

                          
                        </div>                  
                    </div>
           </ModalItem>

           {
              listAnnisites.length > 0 && (
                <div className="row-table-content">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>NO</th>
                          <th>Username</th>
                          <th>Spouse A</th>
                          <th>Spouse B</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Start</th>
                          <th>End</th>
                          <th>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                            listAnnisites.map((item) => {
                              return <tr key={item._id}>
                                      <td></td>
                                      <td>{item.userName}</td>
                                      <td>{item.spouseA}</td>
                                      <td>{item.spouseB}</td>
                                      <td>{item.weddingDate}</td>
                                      <td>{item.weddingTime}</td>
                                      <td>{item.onviteDetails?.mainStart}</td>
                                      <td>{item.onviteDetails?.mainEnd}</td>
                                      <td>
                                        <Link to={'/annisite-details/' + item._id} className="btn btn-primary"> View
                                        </Link>
                                      </td>
                                    </tr>
                            })
                          }
                      </tbody>
                    </table>
                </div>
              )
            }
      </div>
    </div>
  )
}

export default Annisite